import type React from "react";
import { tv, type VariantProps } from "tailwind-variants";

const loaderStyles = tv({
  base: "relative animate-spin-fast",
  variants: {
    intent: {
      current: "text-current",
      primary: "text-primary",
      secondary: "text-muted-foreground",
      success: "text-success",
      warning: "text-warning",
      danger: "text-destructive",
    },
    size: {
      small: "size-4",
      medium: "size-6",
      large: "size-8",
      "extra-large": "size-10",
    },
  },
  defaultVariants: {
    intent: "current",
    size: "small",
  },
});

type LoaderProps = React.ComponentProps<"svg"> &
  VariantProps<typeof loaderStyles>;

export function Loader({ intent, size, className, ...props }: LoaderProps) {
  return (
    <svg
      data-slot="icon"
      width={24}
      height={24}
      fill="none"
      viewBox="0 0 24 24"
      {...props}
      className={loaderStyles({ intent, size, className })}
    >
      <path
        stroke="currentColor"
        strokeOpacity={0.25}
        strokeWidth={3.636}
        d="M11.909 21a9.09 9.09 0 1 0 0-18.182 9.09 9.09 0 0 0 0 18.182Z"
      />
      <path
        fill="currentColor"
        d="M4.636 11.91a7.273 7.273 0 0 1 7.273-7.274V1C5.885 1 1 5.885 1 11.91zm1.819 4.81a7.24 7.24 0 0 1-1.819-4.81H1c0 2.764 1.032 5.294 2.727 7.215z"
      />
    </svg>
  );
}
